import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuluc9 from "components/Phuluc9/Phuluc9.js";
export default function BCPhuluc9() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Hợp tác xã, hộ cá thể kinh doanh vận tải",
            tabContent: <Phuluc9 />,
          },
        ]}
      />
    </div>
  );
}
